<template>
  <div class="mt-8 mx-3">
    <h5 class="mb-2">SMS prices in the last 24hrs</h5>
    <NotificationSwitch v-if="receivedNotifications" />
    <v-data-table :headers="headers" :items="prices">
      <template v-slot:[`item.createdAt`]="{ item }">
        {{ item.createdAt | niceDate }}
      </template>
      <template v-slot:[`item.trend`]="{ item }">
        <v-icon :color="getColor(item.trend)">{{ getIcon(item.trend) }}</v-icon>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { format } from "date-fns";
import NotificationSwitch from "./NotificationSwitch";
export default {
  props: ["prices"],
  components: { NotificationSwitch },
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 2,
      headers: [
        {
          text: "Date | Time",
          align: "start",
          sortable: false,
          value: "createdAt",
        },
        { text: "Price", value: "price" },
        { text: "Volume", value: "volume" },
        { text: "Trend", value: "trend" },
      ],
    };
  },
  created() {
    this.$store.dispatch("notifications/fetchNotification", 1);
  },
  computed: {
    receivedNotifications() {
      return this.$store.getters["notifications/notifications"];
    },
  },
  filters: {
    niceDate(value) {
      return format(new Date(value), "yyyy-MM-dd h:mm a");
    },
  },
  methods: {
    getColor(trend) {
      if (trend === "down") return "red";
      else if (trend === "flat") return "orange";
      else return "green";
    },
    getIcon(trend) {
      if (trend === "down") return "mdi-trending-down";
      else if (trend === "flat") return "mdi-trending-neutral";
      else return "mdi-trending-up";
    },
  },
};
</script>
